var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { Create, EditBase, useRecordContext } from "react-admin";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import { FormContent } from "./FormContent";
/**
 * Wrapper component that accesses the record context to pass presentation data
 */
var FormContentWrapper = function (props) {
    var _a;
    var area_record = useRecordContext();
    if (!area_record)
        return null;
    return (_jsx(FormContent, __assign({}, props, { electionEventId: (_a = props.electionEventId) !== null && _a !== void 0 ? _a : area_record.election_event_id, area_presentation: area_record.presentation })));
};
/** Supports both event drawers and standalone area routes. */
export var UpsertArea = function (props) {
    var _a, _b, _c;
    var routeId = useParams().id;
    var searchParams = useSearchParams()[0];
    var pathname = useLocation().pathname;
    var id = (_a = props.id) !== null && _a !== void 0 ? _a : (pathname.startsWith("/sequent_backend_area/") ? routeId : undefined);
    var electionEventId = (_c = (_b = props.electionEventId) !== null && _b !== void 0 ? _b : searchParams.get("electionEventId")) !== null && _c !== void 0 ? _c : undefined;
    var formProps = __assign(__assign({}, props), { id: id, electionEventId: electionEventId });
    return id ? (_jsx(EditBase, { id: id, resource: "sequent_backend_area", mutationMode: "pessimistic", redirect: false, children: _jsx(PageHeaderStyles.Wrapper, { children: _jsx(FormContentWrapper, __assign({}, formProps)) }) })) : (_jsx(Create, { resource: "sequent_backend_area", redirect: false, children: _jsx(PageHeaderStyles.Wrapper, { children: _jsx(FormContent, __assign({}, formProps)) }) }));
};
